import { defineStore } from 'pinia'
import { round } from 'lodash'

const useBundleStore = defineStore('bundle', {
  state: () => ({
    offers: [],
    selectedOffer: 'OfferOne',
    productPrice: 0,
    tax: 0,
    discount: 0,
    creditsLoading: false,
    hasError: false,
  }),
  getters: {
    total: state => {
      const total = state.productPrice + state.tax - state.discount
      return round(total, 2)
    },
    getOfferByID: state => {
      return (offerID) => {
        return state.offers.find((offer) => (offer.offerID === offerID))
      }
    },
    getOfferTotalByID: state => {
      return (offerID) => {
        const offer = state.offers.find((offer) => (offer.offerID === offerID))
        return (offer?.productPrice ?? 0) + (offer?.tax ?? 0) - state.discount
      }
    }
  },
  actions: {
    setSelectedOffer(offerID) {
      let offerDetails = this.getOfferByID(offerID)
      this.selectedOffer = offerID
      this.productPrice = offerDetails?.productPrice ?? 0
      this.tax = offerDetails?.tax ?? 0
    },
    setOffer(offerID, productPricingInfo) {
      let newOfferValue = {offerID, ...productPricingInfo}
      let duplicateOffer = this.offers.find(offer => offer.offerID === offerID)
      if (duplicateOffer) {
        if (productPricingInfo?.productPrice) {
          duplicateOffer.productPrice = productPricingInfo.productPrice
        }
        if (productPricingInfo?.tax) {
          duplicateOffer.tax = productPricingInfo.tax
        }
      } else {
        this.offers.push(newOfferValue)
      }
    },
    setErrorStatus(status) {
      this.hasError = status
    },
  }
})

export default useBundleStore
